import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Home from "./screens/Home";
import WhatsappButton from "./components/WhatsappButton";

function App() {
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <div className="flex flex-col min-h-100vh">
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
        <WhatsappButton />
      </div>
    </BrowserRouter>
  );
}

export default App;
